import React, { useRef, useState } from "react";
import { User } from "shared/datamodel/schemas/user";
import ShareModalUserCell from "../share-user-model-cell";
import style from "./manage-collaboration-modal.module.css";
import classNames from "classnames";
import useStateValue from "frontend/state/value";
import { UserRole, getUserRole } from "shared/datamodel/schemas/ability";
import StyledButton from "frontend/ui-components/styled-button";
import { useApplyViewerRestricted } from "frontend/hooks/use-apply-viewer-restricted";

export function AccountMember({
  teammate,
  index,
  isOwner = false,
  onRestrictedUserInvite,
}: {
  teammate: User;
  index: number;
  isOwner?: boolean;
  onRestrictedUserInvite?: (user: User) => void;
}) {
  const [{ user }] = useStateValue();

  const [inviteButtonText, setInviteButtonText] = useState("Invite");
  const applyRestrictedLimitation = useApplyViewerRestricted();
  const teammateRole = user && getUserRole(teammate, applyRestrictedLimitation);

  const inviteColumnHidden = true;

  const ref = useRef<HTMLDivElement | null>(null);

  function renderRestrictedMemberInviteButton() {
    if (inviteColumnHidden) {
      return null;
    }
    return (
      <div className={style.invite}>
        {teammateRole === UserRole.Restricted && onRestrictedUserInvite && (
          <StyledButton
            title={inviteButtonText}
            customStyle={{
              width: 57,
              height: 24,
              color: "#FFF",
              fontFamily: "Poppins",
              fontSize: 12,
              fontStyle: "normal",
              fontWeight: 400,
              letterSpacing: "0.219",
            }}
            enabled={inviteButtonText === "Invite"}
            onClick={() => {
              onRestrictedUserInvite(teammate);
              setInviteButtonText("Invited");
            }}
          />
        )}
      </div>
    );
  }

  return (
    <div
      data-testid={teammate.email}
      key={index}
      className={classNames(style.userLine, {
        [style.checkListLine]: isOwner,
        [style.userLineRounded]: true,
      })}
      ref={ref}
    >
      <div className={classNames(style.listUser, { [style.checkListUser]: isOwner })}>
        <ShareModalUserCell key={index} user={teammate} />
      </div>
      {renderRestrictedMemberInviteButton()}
    </div>
  );
}
